import * as React from "react";

interface SlotProps extends React.HTMLAttributes<HTMLElement> {
  children?: React.ReactNode;
}

/**
 * Simple Slot component replacement for @radix-ui/react-slot
 * Merges props from the Slot with its child component
 */
export const Slot = React.forwardRef<HTMLElement, SlotProps>(({ children, ...props }, ref) => {
  if (React.isValidElement(children)) {
    return React.cloneElement(children, {
      ...props,
      ...children.props,
      ref,
      // Merge className if both exist
      className: props.className
        ? `${props.className} ${children.props.className || ""}`.trim()
        : children.props.className,
      // Merge style if both exist
      style: {
        ...props.style,
        ...children.props.style,
      },
      // Merge event handlers
      onClick: (e: React.MouseEvent) => {
        props.onClick?.(e as any);
        children.props.onClick?.(e);
      },
    } as any);
  }

  return <>{children}</>;
});

Slot.displayName = "Slot";
